// extracted by css-extract-rspack-plugin
export default {"cls1":"TopBar-cls1_ZNA","cls2":"TopBar-cls2_7Fe TopBar-cls1_ZNA"};